
import { defineComponent, reactive, ref, watch, onMounted } from "vue";
import SuccessfulModalCustom from "@/components/modal/SuccessfulModalCustom.vue";
import ErrorList from "@/components/commonDesign/ErrorList.vue";
import { ethitransService } from "@/services/EthitransService";
import { validationService } from "@/common/ValidationService";
import { common } from "@/common/services/Common";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  name: "ToDoPhaseChatChannelModel",
  props: {
    showPhaseChannel: { type: Boolean, required: true },
    selectedChannel: { type: Object, required: true }
  },
  components: { ErrorList, SuccessfulModalCustom },
  setup(props, { emit }) {
    const router = useRouter();
    const { params: { projectId } } = useRoute();

    const state = reactive({
      data: {
        phaseChannelList: [] as any,
        successFulMessage: "",
        channelType: { type: "", channelSelected: "", channelName: "" },
        imagesToUpload: [] as any,
        showSuccesCustomModal: false,
      },
      ui: {
        error: { hasError: false, errorList: { phaseChatChannel: [] as any } },
        isLoading: { getPhaseChannelList: false },
        isPostLoading: { proccedForPhaseChannel: false }
      }
    });

    function closeSuccessCustomModal() {
      state.data.showSuccesCustomModal = !state.data.showSuccesCustomModal;
    }

    function hidePhaseChannel() {
      emit("close");
    }

    function proceedForChatChannel() {
      let selectedChannel: any = null;

      if (state.data.channelType.type === "EXISTING") {
        const selectedItem = state.data.phaseChannelList.find(
          (item: any) => item.id === state.data.channelType.channelSelected
        );

        if (selectedItem) {
          selectedChannel = { id: selectedItem.id, name: selectedItem.name };
        }
      } else if (state.data.channelType.type === "NEW") {
        selectedChannel = { id: null, name: state.data.channelType.channelName };
      }

      if (selectedChannel) {
        emit("channelSelected", selectedChannel);
        hidePhaseChannel();
      }
    }

    function getPhaseChannelList() {
      state.ui.error.errorList.phaseChatChannel = [];
      state.ui.error.hasError = false;
      if (state.ui.isLoading.getPhaseChannelList) return;

      state.ui.isLoading.getPhaseChannelList = true;

      ethitransService.channelsByProjectId(projectId.toString())
        .then((res: any) => {
          state.data.phaseChannelList = res.data.data.channels || [];
        })
        .catch((error: any) => {
          common.sdCatchErr(error, state.ui.error.errorList.phaseChatChannel).then((res: any) => {
            state.ui.error.hasError = true;
            for (const [key, value] of Object.entries(res)) {
              if (Array.isArray(value)) {
                state.ui.error.errorList.phaseChatChannel.push(value[0]);
              }
            }
          });
        })
        .finally(() => {
          state.ui.isLoading.getPhaseChannelList = false;
        });
    }

    watch(() => state.data.channelType.type, () => {
      if (state.data.channelType.type === "EXISTING") {
        getPhaseChannelList();
      }
    });

    watch(() => props.selectedChannel, (newChannel: any) => {
      if (newChannel) {
        state.data.channelType.channelSelected = newChannel.id;
      }
    }, { immediate: true });

    function getMemberNames(members: any[]) {
      if (!members || !members.length) return 'No members';
      return `Members: ${members.map(m => m.full_name).join(', ')}`;
    }

    return {
      state,
      closeSuccessCustomModal,
      proceedForChatChannel,
      getPhaseChannelList,
      hidePhaseChannel,
      getMemberNames
    };
  }
});
